import { device } from '@/components/templates/displays/devices'
import * as React from 'react'
import { IGarage } from 'shared-interfaces'
import styled from 'styled-components'
import Icon from '../icons/icon'
import UserAccountCircleLarge from './userAccountCircleLarge'

const Wrapper = styled.section`
    width: 100%;
    height: 100%;
    min-height: 200px;
    background-color: #f7fafa;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-height: 200px;
    border-radius: 5px;
    padding-bottom: 30px;
    padding-top: 30px;
    @media ${device.smallest_laptops} {
        padding-right: 20px;
        padding-left: 20px;
        border-radius: 25px;
    }

    @media ${device.desktop} {
        padding-left: 1vw;
        padding-right: 2vw;
        border-radius: 25px;
    }

    @media ${device.large_desktop} {
        padding-left: 50px;
        padding-right: 60px;
        border-radius: 25px;
    }
`

// background-color: #fafafa;

const Row = styled.div`
    width: 70%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-top: 2px;
    padding-bottom: 2px;
    line-height: 1.7;
    align-items: center;
`

const LeftSide = styled.div`
    width: 70%;
    display: flex;
    padding-top: 2px;
    padding-bottom: 2px;
    line-height: 1.7;
    align-items: center;
`

const RightSide = styled.div`
    width: 25%;
    display: flex;
`

const Col = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    width: 100%;
    max-width: 750px;

    @media ${device.desktop} {
    }

    @media ${device.smallest_laptops} {
    }

    @media ${device.ipad} {
        padding-left: 80px;
    }
    text-align: left !important;
`

const List = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    text-align: left !important;
    @media ${device.large_desktop} {
    }

    @media ${device.desktop} {
    }

    @media ${device.smallest_laptops} {
        padding-right: 0px;
    }
`

const Name = styled.div`
    font-size: 19px;
    font-family: Lato;
    text-transform: uppercase;
    color: black;
    padding-bottom: 5px;
    letter-spacing: 3px;
    @media ${device.smallest_laptops} {
        font-size: 16px;
    }
`

const Description = styled.div`
    font-size: 1.05em;
    font-family: Lato;
    color: black;
    white-space: pre-line;

    @media ${device.smallest_laptops} {
        font-size: 15px;
    }
`

const RowText = styled.div`
    font-family: Lato;
    padding-left: 9px;
    font-size: 14px;
    @media ${device.smallest_laptops} {
        font-size: 13px;
    }
    width: 177px;
    color: rgba(0, 0, 0, 0.65);
`

const DescriptionWidth = styled.div`
    width: 100%;
`

const VerticalLineWrapper = styled.div`
    display: flex;
    min-width: 61px;
    justify-content: center;
    padding-left: 30px;
    padding-right: 30px;
`

const VerticalLine = styled.div`
    height: 100px;
    width: 1px;
    background-color: #efefef;
`

interface Props {
    garage: IGarage
}

const UserBanner: React.FunctionComponent<Props> = (props) => {
    let { garage } = props

    return (
        <Wrapper>
            <LeftSide>
                <UserAccountCircleLarge
                    url={
                        garage.owner.profile_image_url &&
                        garage.owner.profile_image_url
                    }
                    size="90px"
                />

                <Col>
                    <Name>{garage.owner.fullname}</Name>
                    {garage.owner.bio && garage.owner.bio.length > 1 ? (
                        <DescriptionWidth>
                            <Description>{garage.owner.bio} </Description>
                        </DescriptionWidth>
                    ) : (
                        <div
                            style={{
                                fontSize: '14px',
                                fontStyle: 'italic',
                                color: '#a1a1a1',
                            }}
                        >
                            No description
                        </div>
                    )}
                </Col>
            </LeftSide>
            <RightSide>
                <VerticalLineWrapper>
                    <VerticalLine />
                </VerticalLineWrapper>
                <List>
                    <Row>
                        <Icon icon="location" width="16px" />
                        <RowText>
                            {garage.owner.location &&
                            garage.owner.location.length > 1
                                ? garage.owner.location
                                : 'Unknown'}
                        </RowText>
                    </Row>

                    <Row>
                        <Icon icon="car_listed" width="17px" />
                        <RowText>
                            {garage.carIdsList.length}{' '}
                            {garage.carIdsList.length === 1 ? 'car' : 'cars'}
                        </RowText>
                    </Row>
                </List>
            </RightSide>
        </Wrapper>
    )
}

export default UserBanner
